import type { LocalizedString } from "../../../core/schema/Locale.js";

export interface FaqItem {
	question: LocalizedString;
	answer: LocalizedString;
	anchor: LocalizedString;
}

export const christmasFaq: FaqItem[] = [
	{
		question: {
			cs: "Je vaše vánoční cukroví ruční výroby?",
		},
		answer: {
			cs: "Ano, veškeré cukroví vyrábějí ručně naše cukrářky podle tradičních receptur s důrazem na kvalitu všech surovin.",
		},
		anchor: {
			cs: "rucni-vyroba",
		},
	},
	{
		question: {
			cs: "Je možné objednat cukroví ve větším množství?",
		},
		answer: {
			cs: "Jistě! Moc rádi upečeme vánoční cukroví ve větším množství pro firmy či na vánoční akce. Buď zadejte požadované množství do krabice na e-shopu sami, nebo nás kontaktujte na e-mailu objednavky@sladkadilna.cz.",
		},
		anchor: {
			cs: "vetsi-mnozstvi-cukrovi",
		},
	},
	{
		question: {
			cs: "Jak můžu uhradit objednávku?",
		},
		answer: {
			cs: "Platbu můžete v případě objednávky přes e-shop provést on-line kartou, či zvolit dobírku při vyzvednutí (hotově nebo kartou na pobočce). Veškeré podrobnosti o možnosti platby se zobrazí během objednávky.",
		},
		anchor: {
			cs: "jak-uhradim-objednavku",
		},
	},
	{
		question: {
			cs: "Kde si můžu cukroví vyzvednout?",
		},
		answer: {
			cs: "Cukroví bude připraveno k vyzvednutí na našich pobočkách od 12. až do 22. 12. Konkrétní pobočku zvolte v procesu objednávky. Těšíme se!",
		},
		anchor: {
			cs: "kde-si-vyzvednu-cukrovi",
		},
	},
];
